// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Incident API
 * API to get incident information
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const HandlerStatus = {
  statusTriage: 'triage',
  statusLive: 'live',
  statusLearning: 'learning',
  statusClosed: 'closed',
  statusMerged: 'merged',
  statusDeclined: 'declined',
  statusCanceled: 'canceled',
  statusPaused: 'paused',
  statusUnknown: 'unknown',
} as const;
export type HandlerStatus = (typeof HandlerStatus)[keyof typeof HandlerStatus];

export function instanceOfHandlerStatus(value: any): boolean {
  for (const key in HandlerStatus) {
    if (Object.prototype.hasOwnProperty.call(HandlerStatus, key)) {
      if (HandlerStatus[key as keyof typeof HandlerStatus] === value) {
        return true;
      }
    }
  }
  return false;
}

export function HandlerStatusFromJSON(json: any): HandlerStatus {
  return HandlerStatusFromJSONTyped(json, false);
}

export function HandlerStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HandlerStatus {
  return json as HandlerStatus;
}

export function HandlerStatusToJSON(value?: HandlerStatus | null): any {
  return value as any;
}

export function HandlerStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): HandlerStatus {
  return value as HandlerStatus;
}
